module.exports = __webpack_public_path__ + "static/media/na.d618520f.svg";